import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ commissions }) => {
    const empty = (commissions.length === 0);
    if (empty) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Nenhuma comissão efetuada até o momento.
            </div>
        );
    }
    return (
        <div className="table-responsive">
            <table className="table table-hover align-items-center table-flush">
                <TableHead />
                <TableBody commissions={commissions} />
            </table>
        </div>
    );
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/Table.js